module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAOCAMAAAD6xte7AAAATlBMVEUAAACrq6uqqqqpqamvr6+rq6urq6uqqqqrq6uqqqqqqqqxsbGqqqqrq6urq6utra2qqqqqqqqrq6urq6uqqqq/v7+qqqqqqqqrq6uurq5TYurnAAAAGnRSTlMAqa6XEJBqZkYbQhffVE0w1rxeOCoGzMOCJqRinYoAAABcSURBVBjTrY5HEoAgEASBJSo5GP7/UbHQtYqzfezpw5BIZzbCyEQ3ti/FYeQKtXenFaxPY4Rc2P+Oc6fg5IMqpO9fACB4eNEB4ve54efh6pF9yiIAuoFp2O10Jl30YgPWoJZnpQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/slider-icon.png
// module id = 531
// module chunks = 0